export default "__VITE_PUBLIC_ASSET__bc75ea3f__"